<template>
	<tab_header icon="fa-solid fa-house-laptop" title="Controle Manual" />

	<form @submit.prevent="sendCommand">
		<div class="row align-items-end mb-5">
			<div class="col-12 col-md-10">
				<h2>Executar comando</h2>
				<input
					v-model="command"
					name="command"
					type="text"
					class="form-control fw-bolder" />
			</div>
			<div class="col-12 col-md-2 mt-5 mt-md-0">
				<div class="form-check mb-4 mt-4">
					<input
					class="form-check-input"
					type="checkbox"
					v-model="raw_command" />
					<label class="form-check-label">
						Habilitar Comando Bruto
					</label>
				</div>
				<loading_button type="submit" :loading="loading" />
			</div>

			<div
				class="col-12 mt-5"
				v-if="
					command_executed_successfully !== null &&
					!command_executed_successfully
				">
				<div class="alert alert-danger fw-bold">
					Erro: {{ response_error }}
				</div>
			</div>
		</div>
	</form>
	<div class="row">
		<div class="col-12">
			<div
				class="console-output"
				style="max-height: 500px; overflow: scroll; background: black">
				<pre
					class="p-2"
					style="color: #dddddd"
					v-html="command_result"></pre>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import tab_header from './tab_header.vue';
	import { Ref, ref } from 'vue';
	import axios from 'axios';
	import loading_button from '../Widgets/loading_button.vue';

	const props = defineProps({
		manual_command_url: { type: String, required: true },
		computer_uid: { type: String, required: true },
	});

	const command: Ref<string> = ref('cmd /C ');
	const raw_command: Ref<boolean> = ref(true);

	let command_result = '';

	const loading = ref(false);

	const command_executed_successfully: Ref<null | boolean> = ref(null);

	let response_error;

	async function sendCommand() {
		command_result = '';
		loading.value = true;
		command_executed_successfully.value = null;

		axios
			.post(props.manual_command_url, {
				command: command.value,
				raw_command: raw_command.value,
				uid: props.computer_uid,
			})
			.then((response) => {
				command_result += response.data.data.Stdout;
				command_executed_successfully.value = true;
			})
			.catch((response) => {
				command_executed_successfully.value = false;
				response_error = response.response.data.message;
			})
			.finally(() => (loading.value = false));
	}
</script>
